module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle "
  }, [_vm._v("Lily Daw and the Three Ladies")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "dropcap sink follow"
  }, [_c('em', [_vm._v("M")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RS. WATTS")]), _vm._v(" and Mrs. Carson were both in the post office in Victory when the letter came from the Ellisville Institute for the Feeble-Minded of Mississippi. Aimee Slocum, with her hand still full of mail, ran out in front and handed it straight to Mrs. Watts, and they all three read it together. Mrs. Watts held it taut between her pink hands, and Mrs. Carson underscored each line slowly with her thimbled finger. Everybody else in the post office wondered what was up now.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What will Lily say,” beamed Mrs. Carson at last, “when we tell her we’re sending her to Ellisville!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“She’ll be tickled to death,” said Mrs. Watts, and added in a guttural voice to a deaf lady, “Lily Daw’s getting in at Ellisville!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t you all dare go off and tell Lily without "), _c('a', {
    attrs: {
      "id": "p4"
    }
  }), _vm._v("me!” called Aimee Slocum, trotting back to finish putting up the mail.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Do you suppose they’ll look after her down there?” Mrs. Carson began to carry on a conversation with a group of Baptist ladies wailing in the post office. She was the Baptist preacher’s wife.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’ve always heard it was lovely down there, but crowded,” said one.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Lily lets people walk over her so,” said another.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Last night at the tent show—” said another, and then popped her hand over her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t mind me. I know there are such things in the world,” said Mrs. Carson, looking down and fingering the tape measure which hung over her bosom.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh. Mrs. Carson. Well, anyway, last night at the tent show, why, the man was just before making Lily buy a ticket to get in.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“A ticket!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Till my husband went up and explained she wasn’t bright, and so did everybody else.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The ladies all clucked their tongues.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, it was a very nice show,” said the lady who had gone. “And Lily acted so nice. She was a perfect lady—just set in her seat and stared.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, she can be a lady—she can be,” said Mrs. Carson, shaking her head and turning her eyes up. “That’s just what breaks your heart.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yes’m, she kept her eyes on—what’s that thing makes all the commotion?—the xylophone,” said the lady. “Didn’t turn her head to the right or to the left the whole time. Set in front of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The point is, what did she do after the show?” asked Mrs. Watts practically. “Lily has gotten so she is very mature for her age.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, Etta!” protested Mrs. Carson, looking at her wildly for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And that’s how come we are sending her to Ellisville,” finished Mrs. Watts.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m ready, you all,” said Aimee Slocum, running out with white powder all over her face. “Mail’s up. I don’t know how good it’s up.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, of course, I do hope it’s for the best,” said several of the other ladies. They did not go at once to take their mail out of their boxes; they felt a little left out.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The three women stood at the foot of the water tank.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“To find Lily is a different thing,” said Aimee Slocum.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Where in the wide world do you suppose she’d be?” It was Mrs. Watts who was carrying the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I don’t see a sign of her either on this side of the street or on the other side,” Mrs. Carson declared as they walked along.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Ed Newton was stringing Redbird school tablets on the wire across the store.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“If you’re after Lily, she come in here while ago and tole me she was fixin’ to git married,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Ed Newton!” cried the ladies all together, clutching one another. Mrs. Watts began to fan herself at once with the letter from Ellisville. She wore widow’s black, and the least thing made her hot.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Why she is not. She’s going to Ellisville, Ed,” said Mrs. Carson gently. “Mrs. Watts and I and Aimee Slocum are paying her way out of our own pockets. Besides, the boys of Victory are on their honor. Lily’s not going to get married, that’s just an idea she’s got in her head.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“More power to you, ladies,” said Ed Newton, spanking himself with a tablet.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("When they came to the bridge over the railroad tracks, there was Estelle Mabers, sitting on a rail. She was slowly drinking an orange Ne-Hi.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Have you seen Lily?” they asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m supposed to be out here watching for her now,” said the Mabers girl, as though she weren’t there yet. “But for Jewel—Jewel says Lily come in the store while ago and picked out a two-ninety-eight hat and wore it off. Jewel wants to swap her something else for it.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, Estelle, Lily says she’s going to get married!” cried Aimee Slocum.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, I declare,” said Estelle; she never understood anything.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Loralee Adkins came riding by in her Willys-Knight, tooting the horn to find out what they were talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Aimee threw up her hands and ran out into the street. “Loralee, Loralee, you got to ride us up to Lily Daws’. She’s up yonder fixing to get married!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hop in, my land!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, that just goes to show you right now,” said Mrs. Watts, groaning as she was helped into the back seat. “What we’ve got to do is persuade Lily it will be nicer to go to Ellisville.”")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Just to think!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("While they rode around the corner Mrs. Carson was going on in her sad voice, sad as the soft noises in the hen house at twilight. “We buried Lily’s poor defenseless mother. We gave Lily all her food and kindling and every stitch she had on. Sent her to Sunday school to learn the Lord’s teachings, had her baptized a Baptist. And when her old father commenced beating her and tried to cut her head off with the butcher knife, why, we went and took her away from him and gave her a place to stay.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The paintless frame house with all the weather vanes was three stories high in places and had yellow and violet stained-glass windows in front and gingerbread around the porch. It leaned steeply to one side, toward the railroad, and the front steps were gone. The car full of ladies drew up under the cedar tree.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Now Lily’s almost grown up,” Mrs. Carson continued. “In fact, she’s grown,” she concluded, getting out.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Talking about getting married,” said Mrs. Watts disgustedly. “Thanks, Loralee, you run on home.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("They climbed over the dusty zinnias onto the porch and walked through the open door without knocking.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“There certainly is always a funny smell in this house. I say it every time I come,” said Aimee Slocum.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily was there, in the dark of the hall, kneeling on the floor by a small open trunk.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("When she saw them she put a zinnia in her mouth, and held still.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hello, Lily,” said Mrs. Carson reproachfully.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hello,” said Lily. In a minute she gave a suck on the zinnia stem that sounded exactly like a jay bird. There she sat, wearing a petticoat for a dress, one of the things Mrs. Carson kept after her about. Her milky-yellow hair streamed freely "), _c('a', {
    attrs: {
      "id": "p9"
    }
  }), _vm._v("down from under a new hat. You could see the wavy scar on her throat if you knew it was there.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Mrs. Carson and Mrs. Watts, the two fattest, sat in the double rocker. Aimee Slocum sat on the wire chair donated from the drugstore that burned.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, what are you doing, Lily?” asked Mrs. Watts, who led the rocking.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The trunk was old and lined with yellow and brown paper, with an asterisk pattern showing in darker circles and rings. Mutely the ladies indicated to each other that they did not know where in the world it had come from. It was empty except for two bars of soap and a green washcloth, which Lily was now trying to arrange in the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Go on and tell us what you’re doing, Lily,” said Aimee Slocum.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Packing, silly,” said Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Where are you going?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Going to get married, and I bet you wish you was me now,” said Lily. But shyness overcame her suddenly, and she popped the zinnia back into her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Talk to me, dear,” said Mrs. Carson. “Tell old Mrs. Carson why you want to get married.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No,” said Lily, after a moment’s hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, we’ve thought of something that will "), _c('a', {
    attrs: {
      "id": "p10"
    }
  }), _vm._v("be so much nicer,” said Mrs. Carson. “Why don’t you go to Ellisville!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Won’t that be lovely?” said Mrs. Watts. “Goodness, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It’s a lovely place,” said Aimee Slocum uncertainly.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You’ve got bumps on your face,” said Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Aimee, dear, you stay out of this, if you don’t mind,” said Mrs. Carson anxiously. “I don’t know what it is comes over Lily when you come around her.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily stared at Aimee Slocum meditatively.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“There! Wouldn’t you like to go to Ellisville now?” asked Mrs. Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No’m,” said Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Why not?” All the ladies leaned down toward her in impressive astonishment.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“’Cause I’m goin’ to get married,” said Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, and who are you going to marry, dear?” asked Mrs. Watts. She knew how to pin people down and make them deny what they’d already said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily bit her lip and began to smile. She reached into the trunk and held up both cakes of soap and wagged them.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Tell us,” challenged Mrs. Watts. “Who you’re going to marry, now.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“A man last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("There was a gasp from each lady. The possible "), _c('a', {
    attrs: {
      "id": "p11"
    }
  }), _vm._v("reality of a lover descended suddenly like a summer hail over their heads. Mrs. Watts stood up and balanced herself.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“One of those show fellows! A musician!” she cried.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily looked up in admiration.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Did he—did he do anything to you?” In the long run, it was still only Mrs. Watts who could take charge.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, yes’m.” said Lily. She patted the cakes of soap fastidiously with the tips of her small fingers and tucked them in with the washcloth.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What?” demanded Aimee Slocum, rising up and tottering before her scream. “What?” she called out in the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t ask her what,” said Mrs. Carson, coming up behind. “Tell me, Lily—just yes or no—are you the same as you were?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“He had a red coat,” said Lily graciously. “He took little sticks and went "), _c('em', [_vm._v("ping-pong! ding-dong!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, I think I’m going to faint,” said Aimee Slocum, but they said, “No, you’re not.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The xylophone!” cried Mrs. Watts. “The xylophone player! Why, the coward, he ought to be run out of town on a rail!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Out of town? He is out of town, by now,” cried Aimee. “Can’t you read?—the sign in the café—Victory on the ninth, Como on the tenth? He’s in Como. Como!”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p12"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“All right! We’ll bring him back!” cried Mrs. Watts. “He can’t get away from me!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hush,” said Mrs. Carson. “I don’t think it’s any use following that line of reasoning at all. It’s better in the long run for him to be gone out of our lives for good and all. That kind of a man. He was after Lily’s body alone and he wouldn’t ever in this world make the poor little thing happy, even if we went out and forced him to marry her like he ought—at the point of a gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Still—” began Aimee, her eyes widening.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Shut up,” said Mrs. Watts. “Mrs. Carson, you’re right, I expect.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“This is my hope chest—see?” said Lily politely in the pause that followed. “You haven’t even looked at it. I’ve already got soap and a wash rag. And I have my hat—on. What are you all going to give me?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Lily,” said Mrs. Watts, starting over, “we’ll give you lots of gorgeous things if you’ll only go to Ellisville instead of getting married.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What will you give me?” asked Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’ll give you a pair of hemstitched pillowcases,” said Mrs. Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’ll give you a big caramel cake,” said Mrs. Watts.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’ll give you a souvenir from Jackson—a little toy bank,” said Aimee Slocum. “Now will you go?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p13"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No,” said Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’ll give you a pretty little Bible with your name on it in real gold,” said Mrs. Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What if I was to give you a pink crêpe de Chine brassière with adjustable shoulder straps?” asked Mrs. Watts grimly.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, Etta.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, she needs it,” said Mrs. Watts. “What would they think if she ran all over Ellisville in a petticoat looking like a Fiji?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I wish "), _c('em', [_vm._v("I")]), _vm._v(" could go to Ellisville,” said Aimee Slocum luringly.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What will they have for me down there?” asked Lily softly.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh! lots of things. You’ll have baskets to weave, I expect . . .” Mrs. Carson looked vaguely at the others.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, yes indeed, they will let you make all sorts of baskets,” said Mrs. Watts; then her voice too trailed off.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No’m, I’d rather get married,” said Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Lily Daw! Now that’s just plain stubbornness!” cried Mrs. Watts. “You almost said you’d go and then you took it back!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“We’ve all asked God, Lily,” said Mrs. Carson finally, “and God seemed to tell us—Mr. Carson, too—that the place where you ought to be, so as to be happy, was Ellisville.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily looked reverent, but still stubborn.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p14"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“We’ve really just got to get her there—now!” screamed Aimee Slocum all at once. “Suppose—! She can’t stay here!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, no, no, no,” said Mrs. Carson hurriedly. “We mustn’t think that.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("They sat sunken in despair.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Could I take my hope chest—to go to Ellisville?” asked Lily shyly, looking at them sidewise.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Why, yes,” said Mrs. Carson blankly.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Silently they rose once more to their feet.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, if I could just take my hope chest!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“All the time it was just her hope chest,” Aimee whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Mrs. Watts struck her palms together. “It’s settled!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Praise the fathers,” murmured Mrs. Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily looked up at them, and her eyes gleamed. She cocked her head and spoke out in a proud imitation of someone—someone utterly unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“O.K.—Toots!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The ladies had been nodding and smiling and backing away toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I think I’d better stay,” said Mrs. Carson, stopping in her tracks. “Where—where could she have learned that terrible expression?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Pack up,” said Mrs. Watts. “Lily Daw is leaving for Ellisville on Number One.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("In the station the train was puffing. Nearly everyone in Victory was hanging around waiting "), _c('a', {
    attrs: {
      "id": "p15"
    }
  }), _vm._v("for it to leave. The Victory Civic Band had assembled without any orders and was scattered through the crowd. Ed Newton gave false signals to start on his bass horn. A crate full of baby chickens got loose on the platform. Everybody wanted to see Lily all dressed up, but Mrs. Carson and Mrs. Watts had sneaked her into the train from the other side of the tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The two ladies were going to travel as far as Jackson to help Lily change trains and be sure she went in the right direction.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily sat between them on the plush seat with her hair combed and pinned up into a knot under a small blue hat which was Jewel’s exchange for the pretty one. She wore a traveling dress made out of part of Mrs. Watts’s last summer’s mourning. Pink straps glowed through. She had a purse and a Bible and a warm cake in a box, all in her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Aimee Slocum had been getting the outgoing mail stamped and bundled. She stood in the aisle of the coach now, tears shaking from her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Good-bye, Lily,” she said. She was the one who felt things.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Good bye, silly,” said Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, dear, I hope they get our telegram to meet her in Ellisville!” Aimee cried sorrowfully, as she thought how far away it was. “And it was so hard to get it all in ten words, too.” ")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p16"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Get off, Aimee, before the train starts and you break your neck,” said Mrs. Watts, all settled and waving her dressy fan gaily. “I declare, it’s so hot, as soon as we get a few miles out of town I’m going to slip my corset down.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, Lily, don’t cry down there. Just be good, and do what they tell you—it’s all because they love you.” Aimee drew her mouth down. She was backing away, down the aisle.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lily laughed. She pointed across Mrs. Carson’s bosom out the window toward a man. He had stepped off the train and just stood there, by himself. He was a stranger and wore a cap.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Look,” she said, laughing softly through her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t—look,” said Mrs. Carson very distinctly, as if, out of all she had ever spoken, she would impress these two solemn words upon Lily’s soft little brain. She added, “Don’t look at anything till you get to Ellisville.”")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Outside, Aimee Slocum was crying so hard she almost ran into the stranger. He wore a cap and was short and seemed to have on perfume, if such a thing could be.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Could you tell me, madam,” he said, “where a little lady lives in this burg name of Miss Lily Daw?” He lifted his cap—and he had red hair.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p17"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What do you want to know for?” Aimee asked before she knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Talk louder,” said the stranger. He almost whispered, himself.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“She’s gone away—she’s gone to Ellisville!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Gone to Ellisville!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, I like that!” The man stuck out his bottom lip and puffed till his hair jumped.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What business did you have with Lily?” cried Aimee suddenly.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“We was only going to get married, that’s all,” said the man.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Aimee Slocum started to scream in front of all those people. She almost pointed to the long black box she saw lying on the ground at the man’s feet. Then she jumped back in fright.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The xylophone! The xylophone!” she cried, looking back and forth from the man to the hissing train. Which was more terrible? The bell began to ring hollowly, and the man was talking.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Did you say Ellisville? That in the state of Mississippi?” Like lightning he had pulled out a red notebook entitled, “Permanent Facts & Data.” He wrote down something. “I don’t hear well.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Aimee nodded her head up and down, and circled around him.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Under “Ellis-Ville Miss” he was drawing a line; now he was flicking it with two little marks. "), _c('a', {
    attrs: {
      "id": "p18"
    }
  }), _vm._v("“Maybe she didn’t say she would. Maybe she said she wouldn’t.” He suddenly laughed very loudly, after the way he had whispered. Aimee jumped back. “Women!—Well, if we play anywheres near Ellisville, Miss., in the future I may look her up and I may not,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The bass horn sounded the true signal for the band to begin. White steam rushed out of the engine. Usually the train stopped for only a minute in Victory, but the engineer knew Lily from waving at her, and he knew this was her big day.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Wait!” Aimee Slocum did scream. “Wait, mister! I can get her for you. Wait, Mister Engineer! Don’t go!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Then there she was back on the train, screaming in Mrs. Carson’s and Mrs. Watts’s faces.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The xylophone player! The xylophone player to marry her! Yonder he is!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Nonsense,” murmured Mrs. Watts, peering over the others to look where Aimee pointed. “If he’s there I don’t see him. Where is he? You’re looking at One-Eye Beasley.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The little man with the cap—no, with the red hair! Hurry!”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Is that really him?” Mrs. Carson asked Mrs. Watts in wonder. “Mercy! He’s small, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Never saw him before in my life!” cried Mrs. Watts. But suddenly she shut up her fan.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p19"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Come on! This is a train we’re on!” cried Aimee Slocum. Her nerves were all unstrung.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“All right, don’t have a conniption fit, girl,” said Mrs. Watts. “Come on,” she said thickly to Mrs. Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Where are we going now?” asked Lily as they struggled down the aisle.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“We’re taking you to get married,” said Mrs. Watts. “Mrs. Carson, you’d better phone up your husband right there in the station.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“But I don’t want to git married,” said Lily, beginning to whimper. “I’m going to Ellisville.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hush, and we’ll all have some ice-cream cones later,” whispered Mrs. Carson.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Just as they climbed down the steps at the back end of the train, the band went into “Independence March.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The xylophone player was still there, patting his foot. He came up and said, “Hello, Toots. What’s up—tricks?” and kissed Lily with a smack, after which she hung her head.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“So you’re the young man we’ve heard so much about,” said Mrs. Watts. Her smile was brilliant. “Here’s your little Lily.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What say?” asked the xylophone player.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“My husband happens to be the Baptist preacher of Victory,” said Mrs. Carson in a loud, clear voice. “Isn’t that lucky? I can get him here in five minutes: I know exactly where he is.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p20"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("They were in a circle around the xylophone player, all going into the white waiting room.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, I feel just like crying, at a time like this,” said Aimee Slocum. She looked back and saw the train moving slowly away, going under the bridge at Main Street. Then it disappeared around the curve.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Oh, the hope chest!” Aimee cried in a stricken voice.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And whom have we the pleasure of addressing?” Mrs. Watts was shouting, while Mrs. Carson was ringing up the telephone.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The band went on playing. Some of the people thought Lily was on the train, and some swore she wasn’t. Everybody cheered, though, and a straw hat was thrown into the telephone wires.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f204f1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 69
// module chunks = 0